/* istanbul ignore file */
/* eslint-disable no-console */
/**
 * Use for internal usage
 * @ignore
 */
export class Logger {
    prefix = "";
    constructor(namespace) {
        this.prefix = namespace ? `[${namespace}] ` : "";
    }
    log(message, ...args) {
        console.log(`%c${this.prefix}${message}`, "background: #6490f1; color: #fff", ...args);
    }
    warn(message, ...args) {
        console.warn(`%c${this.prefix}${message}`, "background: #6490f1; color: #f80", ...args);
    }
    debug(message, ...args) {
        console.debug(`%c${this.prefix}${message}`, "background: #6490f1; color: #777", ...args);
    }
    error(message, ...args) {
        console.error(`%c${this.prefix}${message}`, "background: #6490f1; color: #f00", ...args);
    }
}
//# sourceMappingURL=index.js.map